import { render, staticRenderFns } from "./InputBatchLelang.vue?vue&type=template&id=e2a581b4&"
import script from "./InputBatchLelang.vue?vue&type=script&lang=js&"
export * from "./InputBatchLelang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports